import Vue from 'vue'

export const collapseParentReactive = Vue.observable({ value: [] })

export default {
    get(){
        return collapseParentReactive.value
    },
    set( active ){
        collapseParentReactive.value = active
    }
}